module.exports = __webpack_public_path__ + "static/level-9-logo.2611bf8b.png";